import { styled } from "@linaria/react";
import Button from "@components/_Revamp/Button";
import { useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import { Helpers } from "@utils/helpers";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { themeDefault } from "src/theme-revamp";
import Leftheart from "@assets/images/cancer-cover-heart.svg";
import RightChecklist from "@assets/images/cancer-cover-checklist.svg";
import { css } from "@linaria/core";
import dayjs from "dayjs";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { store } from "@redux/store";
import { AA } from "@utils/adobeAnalyticsSS";
import { CCP_STEP_LIST } from "@static/content";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";
import { useScreenSize } from "@pages/CCP/Hooks/useScreenSize";
import InnerContainer from "@components/_Revamp/InnerContainer";
import AlertNotification from "@components/_Revamp/AlertNotification";
import alertGreen from "@assets/icon/alert-green-tick.svg";

function QuotationSummary() {
  const quotation = useAvivaSelector(
    (state) => state.cancerCoverStep1.quotation
  );
  const basicInfo = useAvivaSelector(
    (state) => state.cancerCoverStep1.basicInfo
  );
  const productData = useAvivaSelector(
    (state) => state.cancerCoverStep1.productinfo
  );
  const adviser = useAvivaSelector(
    (state) => state.cancerCoverStep6.financialAdviser.adviserData
  );
  const isPromoCodeValid = 'validPromoCode' in adviser &&  adviser?.validPromoCode === "Y";
  const history = useHistory();
  const { isMobile } = useScreenSize();

  //AA Page Loading
  useEffect(() => {
    const AAData = AA.getInstance();
    console.log({
      acquisitionUpdated: {
        customer: {
          DOB: dayjs(basicInfo?.dob).format("DD-MM-YYYY"),
          servicingMode: "",
          marketingOptIn: "",
        },
        product: {
          ...AAData?.digitalData?.acquisition?.product,
          premiumfrequency:
            basicInfo?.paymentOption === "MP" ? "Monthly" : "Annual",
        },
      },
      userUpdated: {
        person: {
          age: quotation?.age?.toString() || "",
          relationship:
            basicInfo?.forwhom === "child"
              ? "Child"
              : basicInfo?.forwhom === "myself"
              ? "Self"
              : "",
        },
      },
    });
    trackOnLoad({
      acquisitionUpdated: {
        customer: {
          DOB: dayjs(basicInfo?.dob).format("DD-MM-YYYY"),
          servicingMode: "",
          marketingOptIn: "",
        },
        product: {
          ...AAData?.digitalData?.acquisition?.product,
          premiumfrequency:
            basicInfo?.paymentOption === "MP" ? "Monthly" : "Annual",
        },
        insurance: {
          paymentOptions: "",
          premium: quotation?.totalPremium?.toString() || "",
        },
      },
      userUpdated: {
        person: {
          age: quotation?.age?.toString() || "",
          relationship:
            basicInfo?.forwhom === "child"
              ? "Child"
              : basicInfo?.forwhom === "myself"
              ? "Self"
              : "",
        },
      },
    });
  }, []);

  return (
    <div className={quotationContainer}>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_QUOTATION_SUMMARY}
        backButtonPath={ROUTE_PATH.CANCER_COVER_BASIC_INFO}
      >
        {isMobile ? null : (
          <>
            <Header>Here’s your quote</Header>
            <Description>
              Check that your plan details are correct before starting the
              health declaration.
            </Description>
          </>
        )}
        {
          isPromoCodeValid ?
            <div className={`${promoCodeBanner}`}>
              <AlertNotification
                iconImg={alertGreen}
                sideBarBackground={"#19D3C5"}
                background={"#eefdfc"}
              >
                <p
                  className={`${promoAlertGreen}`}
                > Promo code applied. You'll get a{" "}
                  <b>
                    {basicInfo?.discountTypeLabel === "dollar"
                      ? `S$${Number(basicInfo?.discountValueLabel).toFixed(2)}`
                      : `${basicInfo?.discountValueLabel}%`}
                    {basicInfo?.paymentOption === "MP" ? ` monthly ` : ``}{" "}
                    discount{" "}
                  </b>{" "}
                  on your first-year premium!
                </p>

              </AlertNotification>
            </div> : null}
        <ViewQuotationContainer>
          <section className="quoteheader">
            <div>Plan Overview</div>
          </section>
          <section className="splitup">
            <div>
              <div>Plan</div>
              <div className="f600">
                {quotation?.planName || productData?.productName}
              </div>
            </div>
            <div>
              <div>Buying for</div>
              <div className="f600">
                {basicInfo?.forwhom === "myself" ? "Myself" : "My Child"}
              </div>
            </div>
            <div>
              <div>Date of Birth</div>
              <div className="f600">
                {dayjs(basicInfo?.dob || new Date()).format("DD MMM YYYY")}
              </div>
            </div>
            <div>
              <div>Payment Frequency</div>
              <div className="f600">
                {basicInfo?.paymentOption === "MP" ? "Monthly" : "Annual"}
              </div>
            </div>
              <hr />
            <div>
              <div>Subtotal Premium</div>
              <div className="f600">
               <b> S${quotation?.annualizePremium}</b>
              </div>
              </div>
              <div>
              <div>{basicInfo?.paymentOption ==="MP" && `Monthly `}Discount {quotation?.promoCodeBE && !isPromoCodeValid  && `(${quotation.promoCodeBE})`}</div>
              <div className={`f600 ${quotation?.premiumDiscount && "green-promo"}`}>
               <b> {quotation?.premiumDiscount ? `-S$${quotation?.premiumDiscount}`:"-"}</b>
              </div>
              </div>
              <div className="bigFont">
              <div>{basicInfo?.paymentOption ==="MP"? `Monthly `: `Annual ` } premium</div>
              <div className="f600">
               <b> S${quotation?.totalPremium || "" }</b>
              </div>
              </div>
          </section>
        </ViewQuotationContainer>
        <ButtonContianer>
          <Button
            variant="default"
            label="Start health declaration"
            onClick={() => {
              trackOnCTA({
                ctaText: "Start health declaration",
                ctaType: "qb:link",
              });
              history.push(ROUTE_PATH.CANCER_COVER_UW_1A);
            }}
          />
        </ButtonContianer>
      </ContainerWithStepper>
      {isMobile ? null : (
        <SideImages>
          <img src={Leftheart} alt="side-image " />
          <img src={RightChecklist} alt="side-image " />
        </SideImages>
      )}
    </div>
  );
}

export default QuotationSummary;

const promoAlertGreen = css`
  color: #0a544f;
`;

const promoCodeBanner = css`
 margin-bottom: 1rem;
`;

const quotationContainer = css`
  min-height: 934px;
`;

const SideImages = styled.div`
  position: absolute;
  width: 100%;
  right: 0;
  left: 0;
  top: 0;
  z-index: -1;
  user-select: none;
  img:nth-child(1) {
    position: absolute;
    width: calc(80% * 100vw);
  }
  img:nth-child(2) {
    position: absolute;
    right: 0;
    top: 500px;
  }
  @media screen and (min-width: 1285px) {
    display: block;
  }
`;

export const Header = styled.div<{ marginTop?: string }>`
  max-width: 70%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: #434343;
  font-size: 18px;
  margin: 0 auto 24px auto;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
    margin-top: ${(prop) => prop.marginTop || "24"}px;
  }
`;

const Description = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  line-height: 140%;
  text-align: center;
  margin: 16px auto 32px auto;
  letter-spacing: 0.015em;
  color: #8a8988;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 18px;
  }
`;

const ViewQuotationContainer = styled.div`

  .green-promo {
    color: #19D3C5;
  }
  background-color: white;
  overflow: hidden;
  border-radius: 16px;
  width: 100%;
  max-width: 792px;
  font-size: 14px;
  margin: 0 auto;
  letter-spacing: 0.42px;
  line-height: 39.2px;
  .f600 {
    font-weight: 600;
  }
  & > section {
    color: #434343;
    padding: 24px;
    h3 {
      color: #883E89;
      font-size: 16px;
      font-weight: 600;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        font-size: 18px;
      }
    }
  }
  .sur-list > li {
    color: #434343;
    span:nth-child(2) {
      float: right;
      font-weight: 600;
    }
  }
  .splitup {

    .bigFont {
        font-size: 24px;
        letter-spacing: 0.36px;
        font-weight: 600;
      }

    .f600 {
      font-weight: 500;
      b{
        font-weight: 600;
      }
    }
    &> hr {
        margin: 24px 0px;
      }
    & > div {
      display: flex;
      padding-bottom: 0px;
      justify-content: space-between;
      width: 100%;
    }

    .surrender-container {
      width: 100%;
      ul {
        padding-left: 30px;
        li {
          padding-bottom: 0px;
        }
        li:last-child {
          padding-bottom: 0px;
        }
      }
    }

    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      & > div {
        padding-bottom: 16px;
      }
      .surrender-container {
        width: 100%;
        ul {
          padding-left: 30px;
          li {
            padding-bottom: 16px;
          }
          li:last-child {
            padding-bottom: 0px;
          }
        }
      }
    }
  }
  .quoteheader {
    background-color: #883E89;
    color: #FFFFFF;
    /* padding: 24px; */
    div:first-child {
      font-size: 18px;
      font-weight: 500;
      line-height: 25.2px;
      color: #ffffff;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .splitup {
      line-height: 22.4px;

      padding: 36px;
      padding-top: 24px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      & > div {
        padding: unset;
      }
      &> hr {
        margin: 24px 0px;
      }
      .bigFont {
        font-size: 24px;
        letter-spacing: 0.36px;
        font-weight: 600;
      }

      .surrender-container {
        ul {
          li {
            padding-bottom: unset;
          }
        }
      }
    }
    .quoteheader {
      div:first-child {
        font-size: 18px;
      }
    }
  }
`;

const premiumContainer = css`
  display: flex;
  font-size: 28px;
  font-weight: 600;
  justify-content: space-between;
  line-height: 39.2px;

  p {
    font-size: 18px;
    letter-spacing: 0.27px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    p {
      font-size: 28px;
    }
  }
`;

const promoContainer = css`
  display: flex;
  justify-content: space-between;
  line-height: 39.2px;
  font-size: 16px;
  font-weight: 600;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 18px;
    font-weight: normal;
  }
`;

const ButtonContianer = styled.div`
  margin: auto;
  margin-top: 50px;
  width: 100%;
  max-width: 288px;
`;
